import {
  AfterViewInit,
  Component,
  EventEmitter,
  input,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges, ViewChild
} from '@angular/core';
import {MatTableDataSource, MatTableModule} from "@angular/material/table";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {MatToolbarModule} from "@angular/material/toolbar";
import {MatButtonModule} from "@angular/material/button";
import {SelectionModel} from "@angular/cdk/collections";
import {NgFor, NgForOf} from "@angular/common";
import {Subscription} from "rxjs";
import {MatPaginator, MatPaginatorModule, PageEvent} from "@angular/material/paginator";

@Component({
  selector: 'app-table-basic',
  standalone: true,
  imports: [
    MatTableModule,
    MatCheckboxModule,
    MatToolbarModule,
    MatButtonModule,
    NgForOf,
    MatPaginatorModule],
  templateUrl: './table-basic.component.html',
  styleUrl: './table-basic.component.css'
})
export class TableBasicComponent implements OnInit, OnDestroy, OnChanges {
  dataSource = input<any>();
  @Input() columnDef: { key: string; header: string }[] = [];
  @Output() selectionChange = new EventEmitter<any[]>();
  @Output() pageChange = new EventEmitter<PageEvent>();

  @ViewChild(MatPaginator) paginator!: MatPaginator;

  private subscriptions: Subscription = new Subscription();

  displayedColumns: string[] = [];
  tableData: any;
  selection = new SelectionModel<any>(true, []);

  ngOnInit() {
    this.initializeTable();
  }

  getNestedValue(obj: any, path: string): any {
    return path.split('.').reduce((acc, part) => acc && acc[part], obj);
  }


  ngOnChanges(changes: SimpleChanges) {
    if (changes['dataSource'] && !changes['dataSource'].isFirstChange()) {
      this.tableData = this.dataSource()?.results;
      this.selection.clear()
    }
    if (changes['columnDef'] && !changes['columnDef'].isFirstChange()) {
      this.initializeTable();
    }
  }

  initializeTable() {
    this.displayedColumns = this.columnDef.map(col => col.key);
    this.displayedColumns.unshift('select');
    this.tableData = this.dataSource()?.results;

    this.selection.changed.subscribe(() => {
      this.selectionChange.emit(this.selection.selected);
    });
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.tableData?.length;
    return numSelected === numRows;
  }

  masterToggle() {
    this.isAllSelected()
      ? this.selection.clear()
      : this.tableData.forEach((row:any) => this.selection.select(row));
  }

  checkboxLabel(row?: any): string {
    if (!row) {
      return `${this.isAllSelected() ? 'deselect' : 'select'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.position + 1}`;
  }

  onPageChange(event: PageEvent) {
    this.pageChange.emit(event);
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
